import React from "react"
import { useTranslation } from "react-i18next"

import type { BillPdfUploadFileStatus } from "@/modules/data/services/use-bill-pdf-upload-session"
import { getBillPdfFileStateLabel } from "@/modules/data/utils/bill-pdf-preview-state"
import { getDisplayValue } from "@/utils/value"

import { LinearProgress, Stack, Typography } from "@mui/material"

interface BillPdfParseProgressProps {
  files: BillPdfUploadFileStatus[]
}

export const BillPdfParseProgress: React.FC<BillPdfParseProgressProps> = ({
  files,
}) => {
  const { t } = useTranslation("data")

  return (
    <Stack
      aria-label={t("upload.billPdf.progressTitle")}
      data-testid="bill-pdf-parse-progress"
      sx={{ gap: 1.5 }}
    >
      <Typography variant="subtitle2">
        {t("upload.billPdf.progressTitle")}
      </Typography>
      <LinearProgress />
      {files.map((file) => (
        <Stack key={file.id ?? file.filename} sx={{ gap: 0.5 }}>
          <Typography variant="body2">
            {getDisplayValue(file.filename)} —{" "}
            {getBillPdfFileStateLabel(file.state, t)}
          </Typography>
          {file.errorMessage ? (
            <Typography color="error" variant="caption">
              {file.errorMessage}
            </Typography>
          ) : null}
        </Stack>
      ))}
    </Stack>
  )
}
